module.exports = __webpack_public_path__ + "img/pohled_z_balkonu_1.525ce957.jpg";